import { Component, EventEmitter, Input, Output, inject, HostListener } from '@angular/core';
import { NzImageService } from 'ng-zorro-antd/image';
import { AppService } from '../../../shared/services/app.service';

@Component({
  selector: 'app-data-preview',
  templateUrl: './data-preview.component.html',
  styleUrl: './data-preview.component.scss',
})
export class DataPreviewComponent {
  @Input() data!: any;
  @Output() menuAction = new EventEmitter<any>();

  private nzImageService = inject(NzImageService);
  private isPreviewOpen = false;
  private previewRef: any = null;

  constructor(public appService: AppService) {}

  @HostListener('document:keydown.escape', ['$event'])
  onEscKeyPress(event: KeyboardEvent): void {
    if (this.isPreviewOpen) {
      this.closeImagePreview();
      event.preventDefault();
      event.stopPropagation();
    }
  }

  onImageClick(): void {
    if (this.data?.chartId) {
      return;
    }

    if (this.data?.dashboardId) {
      const imageData = [
        {
          src: this.getImage(this.data),
          alt: this.data.name,
          width: 'auto',
          height: 'auto',
        },
      ];

      this.previewRef = this.nzImageService.preview(imageData, {
        nzZoom: 1,
        nzRotate: 0,
        nzKeyboard: false,
      });

      this.isPreviewOpen = true;
    }
  }

  private closeImagePreview(): void {
    this.isPreviewOpen = false;

    if (this.previewRef) {
      try {
        this.previewRef.close();
      } catch (e) {
        console.warn('Failed to close image preview:', e);
      }
      this.previewRef = null;
    }
  }

  onMenuAction(action: string): void {
    this.menuAction.emit({ action, data: this.data });
  }

  getImage(data: any): string {
    if (data?.chartId) return this.getChartImage(data);
    return this.getDashboardImage(data);
  }

  getChartImage(chart: any): string {
    return `${this.appService.domainUrl}/images/chart/${chart.engagement}/${chart.chartId}/chart.svg`;
  }

  getDashboardImage(dashboard: any): string {
    return `${this.appService.domainUrl}/images/dashboard/${dashboard.engagement}/${dashboard.dashboardId}/dashboard.png?v=${dashboard.lastModifiedAt}`;
  }
}
